export interface FinalAnswerAuthority {
  answer?: string;
  planStatus?: string;
}

/**
 * A completed command-result response is the authoritative end of a UI turn.
 * The subsequent /answer request is only a reconciliation fetch and can lag
 * behind the verified command receipt, so it must not replace that answer.
 */
export function shouldApplyReconciledAnswer(
  authority: FinalAnswerAuthority,
  reconciledAnswer?: string
): boolean {
  if (!reconciledAnswer?.trim()) return false;
  return !(authority.planStatus === "completed" && authority.answer?.trim());
}
